// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oR6B","title":"Info_title__3PHyB","selects":"Info_selects__1QqV6","requiredAsterisk":"Info_requiredAsterisk__FVE8O"};